import React from "react";
import CardC from "commons/images/card-c.svg";
import CardD from "commons/images/card-d.svg";
import CardE from "commons/images/card-e.svg";
import CardF from "commons/images/card-f.svg";
import CardG from "commons/images/card-g.svg";
import CardH from "commons/images/card-h.svg";

export const descriptions = [
  {
    id: "a",
    label: "Your own digital cookbook",
  },
  {
    id: "b",
    label: "Memory system for the food you love",
  },
  {
    id: "c",
    label: "Hands-free cooking companion",
  },
  {
    id: "d",
    label: "Calculator for custom servings",
  },
  {
    id: "e",
    label: "Unit converter",
  },
  {
    id: "f",
    label: "Set of timers built into the steps",
  },
  {
    id: "g",
    label: "Search engine for what's already in your fridge",
  },
  {
    id: "h",
    label: "Grocery list that writes itself",
  },
  {
    id: "i",
    label: (
      <>
        ”Genuinely so useful” <span style={{ color: "var(--brown-160)" }}>— Carl</span>
      </>
    ),
  },
  // Made in Europe
  // "Import from any website.",
  // "Transform recipes into clean, interactive guides.",
];

export const descriptionsOpposite = [
  { label: "Place where recipes are buried under a life story" },
  { label: "Built on ads, trackers, or cookies" },
  { label: "Another feed to scroll" },
  { label: "AI recipe generator" },
  { label: "Diet app in disguise" },
  { label: "Recommendation engine" },
  { label: "Social media" },
];

export const cards = [
  {
    id: "c",
    label: "Hands-free cooking mode",
    description: (
      <ul>
        <li>The screen stays on!</li>
        <li>See ingredients relevant to the current step without scrolling up and down</li>
      </ul>
    ),
    image: CardC,
  },
  {
    id: "d",
    label: "Calculator for custom servings",
    image: CardD,
    description: (
      <ul>
        <li>Adjust servings up or down with a single click</li>
        <li>Supports half-servings as well</li>
      </ul>
    ),
  },
  {
    id: "e",
    label: "Unit converter",
    image: CardE,
    description: (
      <ul>
        <li>Switch between metric and US units instantly</li>
        <li>Keep the original measurements for double checking</li>
      </ul>
    ),
  },
  {
    id: "f",
    label: "Set of timers built into the steps",
    image: CardF,
    description: (
      <ul>
        <li>Cooking times are interactive - click it and a timer will start</li>
        <li>You can have multiple timers at once</li>
      </ul>
    ),
  },
  {
    id: "g",
    label: "Search engine for what's already in your fridge",
    image: CardG,
    description: (
      <ul>
        <li>Type an ingredient and find every recipe in your library that uses it</li>
        <li>You can combine ingredients as well</li>
      </ul>
    ),
  },
  {
    id: "h",
    label: "Grocery list that writes itself",
    image: CardH,
    description: (
      <ul>
        <li>Generate your list from recipes automatically</li>
        <li>Group by recipe or by supermarket aisle</li>
        <li>The suggestion list remembers the items you buy often</li>
      </ul>
    ),
  },
];
